import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Try /auth/me regardless — session_token httpOnly cookie (Google sign-in)
    // will authenticate even when no JWT is present in localStorage.
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("av_token");
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("av_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    const { data } = await api.post(`/auth/register${ref ? `?ref=${ref}` : ""}`, payload);
    localStorage.setItem("av_token", data.token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => { localStorage.removeItem("av_token"); setUser(null); }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, logout, refresh }),
    [user, loading, login, register, logout, refresh],
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
